import { TFunction } from 'i18next';

export const lang = (t: TFunction, key: string, opt?: any) => t(`modules.accountPayMethod.${key}`, opt);
